import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { BankSepaResource } from "@exonn/js-sdk";

export const module: ModuleOptions<BankSepaResource> = {
  resource: ResourceEnum.BankSepa,
  bigIcon: <i className="icon-20-sepa" />,
  smallIcon: <i className="icon-15-sepa" />,
  disableEdit: true,
  disableCreate: true,
  list: {
    hideDeleteAction: (row) => {
      return !!row.bank_transaction_id;
    },
  },
};
